import React, { useState } from "react";
import { toast } from "sonner";
import { Loader2, Upload } from "lucide-react";
import api, { errMsg } from "@/lib/api";
import { resolveImg } from "@/contexts/SettingsContext";

export default function ImageUploadField({ value, onChange, testid }) {
  const [up, setUp] = useState(false);
  const handle = async (f) => {
    if (!f) return;
    setUp(true);
    try {
      const fd = new FormData();
      fd.append("file", f);
      const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
    } catch (e) { toast.error(errMsg(e.response?.data?.detail)); }
    finally { setUp(false); }
  };
  return (
    <div className="flex items-center gap-3">
      {value ? <img src={resolveImg(value)} alt="" className="w-14 h-14 rounded object-cover border border-[var(--vl-border)]" />
        : <div className="w-14 h-14 rounded bg-[var(--vl-obsidian)] border border-[var(--vl-border)]" />}
      <label className="vl-btn-outline rounded-full px-4 py-2 text-xs flex items-center gap-1.5 cursor-pointer">
        {up ? <Loader2 size={13} className="animate-spin" /> : <Upload size={13} />} Upload
        <input type="file" accept="image/*" className="hidden" data-testid={testid} onChange={(e) => handle(e.target.files?.[0])} />
      </label>
    </div>
  );
}
